const getExperimentVariantFromCookie = (experimentCode: string) => {
  const variantCookieValue = useCookie(`_vwo_feature_${experimentCode}`).value
  return typeof variantCookieValue === 'string' ? variantCookieValue : null
}

export function setupVariantDetection(experimentCode: string) {
  /**
   * @TODO: If there are many `<MoleculeABTestWrapper>` components on the same page with the same experimentCode,
   *        they will each set up this variant detection which will do the exct same work multiple times.
   *        Maybe we can optimize this by having a global variant detection per experimentCode? Or make it run once
   *        by registering it somewhere centrally?
   */
  if (import.meta.client) {
    const experimentsStore = useExperimentsStore()
    onMounted(() => {
      let duration = 0
      const runVariantDetection = () => {
        const variantCookieValue = getExperimentVariantFromCookie(experimentCode)
        if (variantCookieValue) {
          experimentsStore.updateExperiment([experimentCode, { variant: variantCookieValue }])
        }
        if (variantCookieValue || duration >= 10000) {
          // Stop when a value was found or after checking for 10 seconds
          clearInterval(cookieDetectionInterval)
        }
      }
      const cookieDetectionInterval = setInterval(() => {
        duration += 1000
        runVariantDetection()
      }, 1000)
      runVariantDetection()
    })
  }
}
